import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Map, Plane, Compass } from "lucide-react";
import "./notfound.css";

const NotFound = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-container">
        {/* Floating Icons */}
        <motion.div
          animate={{ y: [0, -20, 0], rotate: [0, 10, -10, 0] }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
          className="floating-icon icon-plane"
        >
          <Plane size={64} />
        </motion.div>
        
        <motion.div
          animate={{ y: [0, 30, 0], x: [0, 15, 0] }}
          transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
          className="floating-icon icon-map"
        >
          <Map size={48} />
        </motion.div>

        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
          className="floating-icon icon-compass"
        >
          <Compass size={56} />
        </motion.div>

        {/* 404 Text */}
        <motion.h1
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", bounce: 0.5 }}
          className="not-found-title"
        >
          404
        </motion.h1>

        <motion.h2
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="not-found-subtitle"
        >
          Looks like this page took a gap year.
        </motion.h2>

        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="not-found-text"
        >
          It might be studying abroad, or maybe it just got lost trying to find its classroom. Either way, it's not here!
        </motion.p>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <Link to="/" className="btn-primary-gradient not-found-btn">
            Take Me Back Home
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
